import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import { api } from '@/api/client';
import { onDashboardInvalidated } from '@/composables/useSignalRDashboard';
const counts = ref(null);
const isLoading = ref(false);
let refCount = 0;
let unsubscribe = null;
/** Test-only helper to reset the module-level singleton between test cases. */
export function resetNavCounts() {
    counts.value = null;
    isLoading.value = false;
    refCount = 0;
    unsubscribe = null;
}
const refresh = useDebounceFn(async () => {
    isLoading.value = true;
    try {
        const { data, error } = await api.GET('/v1/nav-counts');
        if (!error && data)
            counts.value = data;
    }
    finally {
        isLoading.value = false;
    }
}, 250);
/**
 * Sidebar + user-menu count source. Backed by GET /v1/nav-counts and
 * invalidated on DashboardHub.summaryInvalidated. Singleton — multiple
 * components calling this share one fetch + one subscription.
 */
export function useNavCounts() {
    onMounted(() => {
        refCount++;
        if (refCount === 1) {
            void refresh();
            unsubscribe = onDashboardInvalidated(() => void refresh());
        }
    });
    onBeforeUnmount(() => {
        refCount--;
        if (refCount === 0 && unsubscribe) {
            unsubscribe();
            unsubscribe = null;
        }
    });
    return { counts, isLoading, refresh };
}
